import { Component } from "react";
import { Button, Card, CardGroup, Container } from "react-bootstrap";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";

import "../../assets/css/partnerProClub.scss";
import "../../assets/css/geral.scss";

import "react-awesome-slider/dist/styles.css";
import AdminHomePageState from "./AdminHomePageState";
import CardInput from "../../models/common/CardInput";
import cloudBanner from "../../assets/img/general/cloud-banner.png";
import eventImage from "../../assets/img/adminPage/scaleTheMontain.jpg";
import planningImage from "../../assets/img/adminPage/planning.jpg";
import worldMap from "../../assets/img/adminPage/world-map.jpg";
import aiCloudOps from "../../assets/img/adminPage/ai-cloud-ops.jpg";

class AdminHomePage extends Component<RouteComponentProps, AdminHomePageState> {
  state: Readonly<AdminHomePageState> = {
    zinfiUrl: process.env.REACT_APP_ZINFI_URL,
    rowOne: [],
    rowTwo: [],
    rowThree: [],
    rowFour: [],
    rowFive: [], // in the future, you can put here the maps...
  };

  canYouHaveAccess() {
    try {
      if (
        process.env.REACT_APP_PROTECT_PAGE === "true" &&
        window.top?.location.host !== process.env.REACT_APP_ALLOW_API
      ) {
        console.log("You shall not pass");
        this.props.history.push("/not-found");
      }
    } catch (err) {}
  }

  componentDidMount() {
    const { zinfiUrl } = this.state;
    this.canYouHaveAccess();
    // const card1 = new CardInput("User Management", "Change, add or search portal users", "/concierge/ucm/#/ucm/38/77/List/0", worldMap);
    // const card2 = new CardInput("Partner Contacts", "Change, add or search partner contacts", "/concierge/ucm/#/ucm/144/1119/List/0", worldMap);
    // const card3 = new CardInput("Partner Accounts", "Change, add or search partner accounts. Here you can add domain addresses to an account.", "/concierge/ucm/#/ucm/144/100/List/0", worldMap);
    // const cardListOne = [card1, card2, card3];

    // const card4 = new CardInput("Profiles", "Change, add or search user profiles", "/concierge/ucm/#/ucm/38/77/List/0", aiCloudOps);
    // const card5 = new CardInput("Groups", "Change, add or search user groups", "/concierge/ucm/#/ucm/38/77/List/0", aiCloudOps);
    // const card6 = new CardInput("Manage Group Segmentation", "Associate one email domain to a especific group." +
    //   " New partners with the setup domain will belong to the choosen group", "/concierge/ucm/#/ucm/38/2453/List/0", aiCloudOps);
    // const cardListTwo = [card4, card5, card6];

    const card7 = new CardInput(
      "NORAM map",
      "PSM map",
      "/world-map/NORAM",
      planningImage,
      false
    );
    const card8 = new CardInput(
      "EMEA map",
      "PSM map",
      "/world-map/EMEA",
      planningImage,
      false
    );
    const card9 = new CardInput(
      "LATAM map",
      "PSM map",
      "/world-map/LATAM",
      planningImage,
      false
    );
    const card10 = new CardInput(
      "APAC map",
      "PSM map",
      "/world-map/APAC",
      planningImage,
      false
    );
    const card14 = new CardInput(
      "Global map",
      "PSM map",
      "/world-map/GLOBAL",
      planningImage,
      false
    );
    const cardListThree = [card7, card8, card9, card10, card14];

    // const card10 = new CardInput("Course Creation", "Create and manage courses (Associate and Professional bootcamps)", "/course-creation", aiCloudOps, false);
    //const card11 = new CardInput("Import excel files", "Import excel files (enrolls, certifications - UNI report, bootcamp previews attendees)", "/parse-excel", aiCloudOps, false);
    // const card12 = new CardInput("Send voucher codes", "Send voucher codes to partners who finish the bootcamp", "/vouchers", aiCloudOps, false);
    //const cardListFour = [card11];

    const card13 = new CardInput(
      "Events",
      "Change, Add or search for training events",
      "/list-events",
      eventImage,
      false
    );
    const cardListFive = [card13];

    this.setState({ rowOne: cardListThree, rowThree: cardListFive });
  }

  goToAddEvent(url) {
    this.props.history.push({
      pathname: url,
    });
  }

  getCards(cards: Array<CardInput>) {
    const { zinfiUrl } = this.state;
    return cards.map((c) => {
      const path = c.image || planningImage;
      const finalLink = c.putZinfiLink === false ? c.link : zinfiUrl + c.link;
      return (
        <Card style={{ width: "18rem" }}>
          <Card.Img variant="top" src={path} />
          <Card.Body>
            <Card.Title>{c.title}</Card.Title>
            <Card.Text>{c.text}</Card.Text>
            {/* <Button className="mt-2 " target="_blank" variant="primary" onClick={() => this.redirectTo(c.link, true)}>Go</Button> */}
            {c.putZinfiLink === false ? (
              <Button
                className="mt-2 "
                onClick={() => this.goToAddEvent(finalLink)}
                variant="primary"
              >
                Go
              </Button>
            ) : (
              <Button
                className="mt-2 "
                target="_parent"
                variant="primary"
                href={finalLink}
              >
                Go
              </Button>
            )}
          </Card.Body>
        </Card>
      );
    });
  }

  getBanner() {
    const { zinfiUrl } = this.state;
    return (
      <Card className="bg-dark text-white m-5">
        <Card.Img src={cloudBanner} alt="Card image" />
        <Card.ImgOverlay className="mt-5 text-center">
          <h2>For Dynatrace</h2>
          <h5> Talk with gary.llil@dynatrace.com</h5>
          {/* <Button className="mt-2 mr-2" target="_blank" variant="danger" onClick={() => this.redirectTo("/concierge/ucm/#/ucm/38/content", true)}>old admin page</Button>
      <Button className="mt-2" target="_blank" variant="danger" onClick={() => this.redirectTo("https://help.zinfi.net/concierge/ucm/#/ucm/2084/content", false)}>ZINFI documentation</Button> */}
          {/*<Button className="mt-2 mr-2" target="_parent" variant="danger" href={zinfiUrl + "/concierge/ucm/#/ucm/38/content"} >old admin page</Button>
        <Button className="mt-2" target="_blank" variant="danger" href="https://help.zinfi.net/concierge/ucm/#/ucm/2084/content">ZINFI documentation</Button>*/}
        </Card.ImgOverlay>
      </Card>
    );
  }

  render() {
    const { rowOne, rowTwo, rowThree, rowFour, rowFive } = this.state;

    return (
      <>
        {this.getBanner()}
        <Container className="mt-3">
          <h4>MAPS</h4>
          <CardGroup className="mb-3">{this.getCards(rowOne)}</CardGroup>
          {/* <h4>COURSE MANAGEMENT</h4>
          <CardGroup className="mb-3">
            {this.getCards(rowTwo)}
          </CardGroup> */}
          <h4>EVENTS</h4>
          <CardGroup className="mb-3">{this.getCards(rowThree)}</CardGroup>
        </Container>
      </>
    );
  }
}

export default withRouter(AdminHomePage);
